import { Reveal } from "../components/MaskedReveal";
import { IMAGES } from "../lib/images";

const CHAPTERS = [
  {
    n: "01",
    title: "A relaxed table, not a lecture",
    body: "No swirling snobbery, no impossible vocabulary. Just good bottles, honest conversation and people happy to learn a little more about what's in the glass.",
  },
  {
    n: "02",
    title: "Discover together, locally",
    body: "From boutique cellar doors to long lunches among the vines, we explore the wine regions on Macarthur's doorstep — and share the ones worth going back for",
  },
  {
    n: "03",
    title: "Meet like-minded locals",
    body: "For wine lovers of all ages who'd like to widen their circle. Come alone or bring a friend — you'll leave with a few more.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Left sticky intro + image */}
          <div className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <Reveal>
                <span className="text-xs uppercase tracking-[0.28em] text-gold">Our little manifesto</span>
                <h2 className="mt-6 font-display leading-[0.95] tracking-tight text-cream text-[clamp(2.4rem,5vw,4.2rem)]">
                  A love of wine <span className="italic text-terracotta">&amp; good company.</span>
                </h2>
                <p className="mt-6 max-w-md text-smoke leading-relaxed">
                  We're forming a social wine society in the Macarthur region — the
                  kind of group you wish already existed. Here's what we're about.
                </p>
              </Reveal>

              <Reveal delay={0.15} className="mt-10 overflow-hidden arch">
                <img
                  src={IMAGES.toasting}
                  alt="Friends toasting wine glasses"
                  className="h-[380px] w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </Reveal>
            </div>
          </div>

          {/* Right chapters */}
          <div className="md:col-span-7 md:pl-8">
            <div className="flex flex-col">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.05}>
                  <div className="group border-t border-white/10 py-10 md:py-14">
                    <div className="flex items-start gap-6 md:gap-10">
                      <span className="font-display text-4xl md:text-6xl text-gold/90 leading-none">{c.n}</span>
                      <div>
                        <h3 className="font-display text-2xl md:text-4xl text-cream tracking-tight">{c.title}</h3>
                        <p className="mt-4 max-w-xl text-smoke leading-relaxed md:text-lg">{c.body}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
              <div className="border-t border-white/10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
